import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from '../comum/filtros/pipes/pipes.module';
import { ComumModule } from '../comum/comum.module';
import { routing } from '../rotas';
import { ListarSetoresComponent } from './listar-setores/listar-setores.component';
import { CadastroSetorComponent } from './cadastro-setor/cadastro-setor.component';
import { ListarPontoFisicoSetorComponent } from './listar-ponto-fisico-setor/listar-ponto-fisico-setor.component';
import { FormsModule } from '@angular/forms';
import { SetorService } from './setor.service';
import { PontoFisicoService } from '../ponto-fisico/ponto-fisico.service';
import { ModalSetoresClienteComponent } from './modal-setores-cliente/modal-setores-cliente.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { SetorTabsetComponent } from './setor-tabset/setor-tabset.component';
import { ListarSetoresClienteComponent } from './listar-setores-cliente/listar-setores-cliente.component';
import { ModalPontoFisicoSetorComponent } from './modal-ponto-fisico-setor/modal-ponto-fisico-setor.component';
import { PontoFisicoSetorComponent } from './ponto-fisico-setor/ponto-fisico-setor.component';
import { ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/services/cookies.service';

@NgModule({
  imports: [
    CommonModule,
    NgxPaginationModule,
    NgbModule,
    PipesModule,
    ComumModule,
    routing,
    FormsModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    }),
    ConfirmDialogModule
  ],
  declarations: [ListarSetoresComponent, CadastroSetorComponent, ListarPontoFisicoSetorComponent,
    ModalSetoresClienteComponent, SetorTabsetComponent, ListarSetoresClienteComponent,
    ModalPontoFisicoSetorComponent, PontoFisicoSetorComponent],
  exports: [ListarSetoresComponent, CadastroSetorComponent, ListarPontoFisicoSetorComponent,
    ModalSetoresClienteComponent, SetorTabsetComponent, ListarSetoresClienteComponent,
    ModalPontoFisicoSetorComponent, PontoFisicoSetorComponent],
  providers: [SetorService, PontoFisicoService, ConfirmationService, CookieService]
})
export class SetorModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/setor/setor.module.ts